import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselSwiperComponent } from './carousel-swiper.component';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    CarouselSwiperComponent
  ],
  providers: [
  ],
  declarations: [
    CarouselSwiperComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CarouselSwiperModule { }
